import type { GaEventParams } from "../types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callGtag(command: string, ...args: unknown[]): void {
  if (typeof window === "undefined") return;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  if (typeof w.gtag === "function") {
    w.gtag(command, ...args);
  } else {
    // Fallback: queue directly in dataLayer (gtag format)
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push([command, ...args]);
  }
}

export function isGtagAvailable(): boolean {
  return (
    typeof window !== "undefined" &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Array.isArray((window as any).dataLayer)
  );
}

export function gtagEvent(eventName: string, params?: GaEventParams): void {
  const cleaned: Record<string, string | number | boolean> = {};
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) {
        cleaned[key] = value;
      }
    }
  }
  callGtag("event", eventName, cleaned);
}

export function gtagConfig(
  measurementId: string,
  params: Record<string, unknown>
): void {
  callGtag("config", measurementId, params);
}

export function gtagSetUserProperties(
  properties: Record<string, string | number | boolean | null>
): void {
  callGtag("set", "user_properties", properties);
}

export function gtagConsentUpdate(
  signals: Partial<
    Record<
      | "ad_storage"
      | "analytics_storage"
      | "ad_user_data"
      | "ad_personalization",
      "granted" | "denied"
    >
  >
): void {
  callGtag("consent", "update", signals);
}
